import { css } from "styled-components";

export const errorButtonStyles = ($dark: boolean) => {
  return css`
    background: transparent;
    border: 1px solid var(--sys-red-1);
    & > p {
      color: var(--sys-red-1);
    }
    & > svg path {
      stroke: var(--sys-red-1);
    }
    &:hover {
      background: ${$dark
        ? "rgba(203, 203, 207, 0.24)"
        : "rgba(139, 139, 147, 0.24)"};
    }
    &:active {
      background: ${$dark
        ? "rgba(254, 254, 254, 0.32)"
        : "rgba(7, 7, 7, 0.32)"};
    }
  `;
};
